import React, { useState } from 'react';
import { X, FileText, MessageSquare, Download, CheckCircle2 } from 'lucide-react';
import './DownloadReportModal.css';

interface DownloadReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDownload: (includeTranscript: boolean) => void;
  loading?: boolean;
}

const DownloadReportModal: React.FC<DownloadReportModalProps> = ({ isOpen, onClose, onDownload, loading }) => {
  const [includeTranscript, setIncludeTranscript] = useState(true);

  if (!isOpen) return null;

  return (
    <div className="download-modal-overlay" onClick={onClose}>
      <div className="download-modal-container" onClick={e => e.stopPropagation()}>
        <button className="download-modal-close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="download-modal-header">
          <div className="download-icon-bg">
            <Download size={24} />
          </div>
          <h2>Configure Your Report</h2>
          <p>Choose your preferred report format before downloading.</p>
        </div>

        <div className="download-options-grid">
          <div 
            className={`download-option-card ${includeTranscript ? 'active' : ''}`}
            onClick={() => setIncludeTranscript(true)}
          >
            <div className="option-check">
              {includeTranscript && <CheckCircle2 size={18} />}
            </div>
            <div className="option-icon">
              <MessageSquare size={24} />
            </div>
            <div className="option-info">
              <h4>With Transcript</h4>
              <p>Includes full conversation history and analysis.</p>
            </div>
          </div>

          <div 
            className={`download-option-card ${!includeTranscript ? 'active' : ''}`}
            onClick={() => setIncludeTranscript(false)}
          >
            <div className="option-check">
              {!includeTranscript && <CheckCircle2 size={18} />}
            </div>
            <div className="option-icon">
              <FileText size={24} />
            </div>
            <div className="option-info">
              <h4>Without Transcript</h4>
              <p>Summarized performance metrics only.</p>
            </div>
          </div>
        </div>

        <div className="download-modal-footer">
          <button className="btn-cancel" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button 
            className="btn-download-final" 
            onClick={() => onDownload(includeTranscript)}
            disabled={loading}
          >
            {loading ? 'Preparing Report...' : 'Download Report'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadReportModal;
